import firebase from 'firebase/app'
import 'firebase/auth'
import gen from '../gen'

const state = {
  emailMagin_login_email: ''
}

const getters = {

}

const mutations = {
  //
  emailMagic_login(state2, payload){ 
    //
    gen.state.btnLoader = true
    //
    let email = state.emailMagin_login_email
    //

    const actionCodeSettings = {
      // Your redirect URL
      url: window.location.origin + '/complete-signin', 
      handleCodeInApp: true,
    };

    firebase
      .auth()
      .sendSignInLinkToEmail(email, actionCodeSettings)
      .then(()=>{

        gen.mutations.snackbar_alert(state, {
          msg: 'Login link has been sent to your mail: ' + email
        })

        localStorage.setItem('emailForSignIn', email)
        //
        state.emailMagin_login_email = ''
        
        gen.state.btnLoader = false

      }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // ...
      gen.mutations.snackbar_alert(state, {
        msg: error.message
      })
      //
      gen.state.btnLoader = false
      //
    });
    //
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/emailMagic_login.js